import React, {useState}    from "react";
import PropTypes            from 'prop-types';
import ModalBoxPagination   from "./Components/ModalBoxPagination";
import ModalBoxCloseBar     from "./Components/ModalBoxCloseBar";
import ModalBoxClose        from "./Components/ModalBoxClose";
import ModalBox             from "./Components/ModalBox";
import withMobileViewChange from "../../HigherOrderComponents/Utility/withMobileViewChange";

function ModalBoxWrapper(props) {
    const [page, setPage] = useState(0);
    const currentPage     = props.pages[page];

    return <ModalBox variableHeight={props.variableHeight}
                     withPaddingTop={props.forceNoPaddingTop ? false : !props.showCloseBar || props.isMobile}
                     withPaddingBottom={props.forceNoPaddingBottom ? false : props.pages.length < 2}
                     fixedWidth={props.fixedWidth}>
        {props.showCloseBar && !props.isMobile && <ModalBoxCloseBar text={props.title} onClose={props.onClose} />}
        {((!props.showCloseBar || props.isMobile) && !props.hideClose) && <ModalBoxClose onClose={props.onClose} />}
        {currentPage}
        <ModalBoxPagination pagesCount={props.pages.length} setPage={setPage} page={page} badge={props.pagination?.badge} />
    </ModalBox>;
}

ModalBoxWrapper.propTypes = {
    isMobile:             PropTypes.bool,
    showCloseBar:         PropTypes.bool,
    onClose:              PropTypes.func,
    title:                PropTypes.string,
    variableHeight:       PropTypes.bool,
    pagination:           {
        badge: PropTypes.string,
    },
    pages:                PropTypes.arrayOf(PropTypes.node),
    fixedWidth:           PropTypes.bool,
    hideClose:            PropTypes.bool,
    forceNoPaddingTop:    PropTypes.bool,
    forceNoPaddingBottom: PropTypes.bool,
};

ModalBoxWrapper.defaultProps = {
    isMobile:             true,
    variableHeight:       false,
    onClose:              null,
    title:                "",
    pagination:           {
        badge: "",
    },
    pages:                [],
    fixedWidth:           false,
    hideClose:            false,
    forceNoPaddingTop:    false,
    forceNoPaddingBottom: false,
};

export default withMobileViewChange(ModalBoxWrapper);
